import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
const getSavedLocale = () => {
  const savedLocale = localStorage.getItem('user-locale')
  return savedLocale || 'en'
}

const i18n = createI18n({
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

export function setLocale(locale) {
  i18n.global.locale = locale
  localStorage.setItem('user-locale', locale)
}

export default i18n
